module.exports = __webpack_public_path__ + "media/images/athletes/3590-1432ae76b6a13a7a5ef03a5df87408bd.png";